import { IconButton } from '@assembly-js/design-system';
import { createStyles, LinearProgress, makeStyles } from '@material-ui/core';
import { MouseEventHandler, PropsWithChildren } from 'react';

import { LoadingWrapper } from 'src/legacy/components/Loading';

const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      '*': {
        margin: 0,
      },
      html: {
        height: '100%',
      },
      body: {
        height: '100%',
      },
    },
  }),
);

interface OnboardingPageLayout {
  onClickBack: MouseEventHandler<HTMLButtonElement>;
  progressPercent: number;
  isLoading: boolean;
}

export const OnboardingPageLayout = ({
  onClickBack,
  progressPercent,
  isLoading,
  children,
}: PropsWithChildren<OnboardingPageLayout>) => {
  useStyles();

  return (
    <LoadingWrapper hideContentWhileLoading isLoading={isLoading}>
      <div className="min-h-screen flex bg-gray-100">
        <div className="relative flex-1 sm:m-1 bg-white rounded-4 overflow-hidden">
          <LinearProgress
            classes={{
              root: 'bg-secondary-hover hidden sm:block',
              bar: 'rounded-full',
            }}
            variant="determinate"
            value={progressPercent}
          />
          <div className="max-w-[560px] px-4 ml-auto mr-auto mt-16 sm:mt-[92px] pb-6">
            <LinearProgress
              classes={{
                root: 'bg-secondary-hover rounded-full mb-6 block sm:hidden',
                bar: 'rounded-full',
              }}
              variant="determinate"
              value={progressPercent}
            />
            <IconButton
              className="absolute top-4 left-4"
              variant="minimal"
              icon="ArrowLeft"
              onClick={onClickBack}
            />
            {children}
          </div>
        </div>
      </div>
    </LoadingWrapper>
  );
};
